import { currencyFormatter } from "../../utils/Utils";

import { Link as RouterLink } from "@tanstack/react-router";
import { CardActionArea } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";

export default function DashboardCard({
  currency,
  heading,
  subheading,
  icon,
  link,
  iconColour,
  newTab,
}) {
  const formatter = (value) =>
    new Intl.NumberFormat("en-GB", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      trailingZeroDisplay: "stripIfInteger",
    }).format(value.replace(",", ""));

  return (
    <Card elevation={2} sx={{ width: "100%", height: "100%" }}>
      <CardActionArea
        component={RouterLink}
        to={link}
        target={newTab ? "_blank" : "_self"}
        sx={{ height: "100%" }}
      >
        <CardContent
          sx={{ height: "100%", py: 2, justifyContent: "center" }}
          component={Stack}
        >
          <Stack
            direction="row"
            spacing={2}
            useFlexGap
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Stack
              sx={{
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              <Typography component="div" variant="subtitle1">
                {heading}
              </Typography>
              {subheading && (
                <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    color: "text.secondary",
                  }}
                >
                  {currency
                    ? currencyFormatter("GB", subheading)
                    : formatter(subheading)}
                </Typography>
              )}
            </Stack>
            <Avatar
              sx={{
                bgcolor: iconColour,
                width: { xs: 48 },
                height: { xs: 48 },
              }}
              variant="rounded"
            >
              {icon}
            </Avatar>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
